// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderProfessionalClaim,
    ProviderProfessionalClaimTemplate,
    ProviderProfessionalSortType,
    SupportCreateClaimProfessionalPayload,
    SupportCreateProfessionalClaimPayload,
    SupportCreateProfessionalClaimTemplatePayload,
    SupportProfessionalClaim,
    SupportProfessionalClaimTemplate,
    SupportProfessionalSortType,
    SupportProfessionalTemplateSortType,
    SupportReplaceProfessionalTemplatePayload,
    SupportUpdateProfessionalClaimCollectionMemoPayload,
    SupportUpdateProfessionalClaimSelfPayPayload,
    SupportCreateProfessionalClaimPayloadToJSON,
    SupportCreateProfessionalClaimTemplatePayloadToJSON,
    SupportReplaceProfessionalTemplatePayloadToJSON,
    SupportUpdateProfessionalClaimCollectionMemoPayloadToJSON,
    SupportUpdateProfessionalClaimSelfPayPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderProfessionalClaimFromJSON,
    ProviderProfessionalClaimTemplateFromJSON,
    SupportCreateClaimProfessionalPayloadFromJSON,
    SupportProfessionalClaimFromJSON,
    SupportProfessionalClaimTemplateFromJSON,
} from '../models';

export interface CreateSupportProfessionalClaimRequest {
    supportCreateProfessionalClaimPayload: SupportCreateProfessionalClaimPayload;
}

export interface CreateSupportProfessionalClaimTemplateRequest {
    supportCreateProfessionalClaimTemplatePayload: SupportCreateProfessionalClaimTemplatePayload;
}

export interface DisableSupportProfessionalClaimRequest {
    pid: string;
}

export interface DisableSupportProfessionalClaimTemplateRequest {
    id: string;
}

export interface GetProviderProfessionalClaimRequest {
    pid: string;
}

export interface GetProviderProfessionalClaimTemplateRequest {
    id: string;
}

export interface GetSupportProfessionalClaimRequest {
    pid: string;
}

export interface GetSupportProfessionalClaimClaimPayloadRequest {
    id: string;
}

export interface GetSupportProfessionalClaimPayloadRequest {
    pid: string;
}

export interface GetSupportProfessionalClaimTemplateRequest {
    id: string;
}

export interface ListProviderProfessionalClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderProfessionalClaimsOrderEnum>;
    filterCreated?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterChargemasterId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterReferralNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<ProviderProfessionalSortType>;
}

export interface ListSupportProfessionalClaimTemplatesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportProfessionalClaimTemplatesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    sort?: Array<SupportProfessionalTemplateSortType>;
}

export interface ListSupportProfessionalClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportProfessionalClaimsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterChargemasterId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterReferralNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<SupportProfessionalSortType>;
}

export interface PostSupportProfessionalClaimCollectionMemoRequest {
    pid: string;
    supportUpdateProfessionalClaimCollectionMemoPayload: SupportUpdateProfessionalClaimCollectionMemoPayload;
}

export interface PostSupportProfessionalClaimSelfPayRequest {
    pid: string;
    supportUpdateProfessionalClaimSelfPayPayload: SupportUpdateProfessionalClaimSelfPayPayload;
}

export interface ReplaceSupportProfessionalTemplateRequest {
    supportReplaceProfessionalTemplatePayload: SupportReplaceProfessionalTemplatePayload;
}

/**
 * no description
 */
export class ProfessionalApi extends runtime.BaseAPI {

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createSupportProfessionalClaimRaw(requestParameters: CreateSupportProfessionalClaimRequest): Promise<runtime.ApiResponse<SupportProfessionalClaim>> {
        if (requestParameters['supportCreateProfessionalClaimPayload'] === null || requestParameters['supportCreateProfessionalClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateProfessionalClaimPayload','Required parameter requestParameters.supportCreateProfessionalClaimPayload was null or undefined when calling createSupportProfessionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateProfessionalClaimPayloadToJSON(requestParameters['supportCreateProfessionalClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProfessionalClaimFromJSON(jsonValue));
    }

    /**
     * Create a professional claim
     * Create a professional claim
     */
    async createSupportProfessionalClaim(requestParameters: CreateSupportProfessionalClaimRequest): Promise<SupportProfessionalClaim> {
        const response = await this.createSupportProfessionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a professional claim template
     * Create a professional claim template
     */
    async createSupportProfessionalClaimTemplateRaw(requestParameters: CreateSupportProfessionalClaimTemplateRequest): Promise<runtime.ApiResponse<SupportProfessionalClaimTemplate>> {
        if (requestParameters['supportCreateProfessionalClaimTemplatePayload'] === null || requestParameters['supportCreateProfessionalClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateProfessionalClaimTemplatePayload','Required parameter requestParameters.supportCreateProfessionalClaimTemplatePayload was null or undefined when calling createSupportProfessionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateProfessionalClaimTemplatePayloadToJSON(requestParameters['supportCreateProfessionalClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProfessionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Create a professional claim template
     * Create a professional claim template
     */
    async createSupportProfessionalClaimTemplate(requestParameters: CreateSupportProfessionalClaimTemplateRequest): Promise<SupportProfessionalClaimTemplate> {
        const response = await this.createSupportProfessionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a professional claim
     * Disable a professional claim
     */
    async disableSupportProfessionalClaimRaw(requestParameters: DisableSupportProfessionalClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling disableSupportProfessionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:professional", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/{pid}/disable`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a professional claim
     * Disable a professional claim
     */
    async disableSupportProfessionalClaim(requestParameters: DisableSupportProfessionalClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportProfessionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a professional claim template
     * Disable a professional claim template
     */
    async disableSupportProfessionalClaimTemplateRaw(requestParameters: DisableSupportProfessionalClaimTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportProfessionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:professional", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/template/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a professional claim template
     * Disable a professional claim template
     */
    async disableSupportProfessionalClaimTemplate(requestParameters: DisableSupportProfessionalClaimTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportProfessionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim
     * Get a professional claim
     */
    async getProviderProfessionalClaimRaw(requestParameters: GetProviderProfessionalClaimRequest): Promise<runtime.ApiResponse<ProviderProfessionalClaim>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling getProviderProfessionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/professional/{pid}`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProfessionalClaimFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim
     * Get a professional claim
     */
    async getProviderProfessionalClaim(requestParameters: GetProviderProfessionalClaimRequest): Promise<ProviderProfessionalClaim> {
        const response = await this.getProviderProfessionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim template
     * Get a professional claim template
     */
    async getProviderProfessionalClaimTemplateRaw(requestParameters: GetProviderProfessionalClaimTemplateRequest): Promise<runtime.ApiResponse<ProviderProfessionalClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderProfessionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/professional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProfessionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim template
     * Get a professional claim template
     */
    async getProviderProfessionalClaimTemplate(requestParameters: GetProviderProfessionalClaimTemplateRequest): Promise<ProviderProfessionalClaimTemplate> {
        const response = await this.getProviderProfessionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim
     * Get a professional claim
     */
    async getSupportProfessionalClaimRaw(requestParameters: GetSupportProfessionalClaimRequest): Promise<runtime.ApiResponse<SupportProfessionalClaim>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling getSupportProfessionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/{pid}`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProfessionalClaimFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim
     * Get a professional claim
     */
    async getSupportProfessionalClaim(requestParameters: GetSupportProfessionalClaimRequest): Promise<SupportProfessionalClaim> {
        const response = await this.getSupportProfessionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim payload
     * Get a professional claim payload
     */
    async getSupportProfessionalClaimClaimPayloadRaw(requestParameters: GetSupportProfessionalClaimClaimPayloadRequest): Promise<runtime.ApiResponse<SupportCreateClaimProfessionalPayload>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportProfessionalClaimClaimPayload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/claim/{id}/payload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCreateClaimProfessionalPayloadFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim payload
     * Get a professional claim payload
     */
    async getSupportProfessionalClaimClaimPayload(requestParameters: GetSupportProfessionalClaimClaimPayloadRequest): Promise<SupportCreateClaimProfessionalPayload> {
        const response = await this.getSupportProfessionalClaimClaimPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim payload
     * Get a professional claim payload
     */
    async getSupportProfessionalClaimPayloadRaw(requestParameters: GetSupportProfessionalClaimPayloadRequest): Promise<runtime.ApiResponse<SupportCreateClaimProfessionalPayload>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling getSupportProfessionalClaimPayload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/{pid}/payload`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCreateClaimProfessionalPayloadFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim payload
     * Get a professional claim payload
     */
    async getSupportProfessionalClaimPayload(requestParameters: GetSupportProfessionalClaimPayloadRequest): Promise<SupportCreateClaimProfessionalPayload> {
        const response = await this.getSupportProfessionalClaimPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a professional claim template
     * Get a professional claim template
     */
    async getSupportProfessionalClaimTemplateRaw(requestParameters: GetSupportProfessionalClaimTemplateRequest): Promise<runtime.ApiResponse<SupportProfessionalClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportProfessionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProfessionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a professional claim template
     * Get a professional claim template
     */
    async getSupportProfessionalClaimTemplate(requestParameters: GetSupportProfessionalClaimTemplateRequest): Promise<SupportProfessionalClaimTemplate> {
        const response = await this.getSupportProfessionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of professional claims
     * Get a list of professional claims
     */
    async listProviderProfessionalClaimsRaw(requestParameters: ListProviderProfessionalClaimsRequest): Promise<runtime.ApiResponse<Array<ProviderProfessionalClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterChargemasterId) {
            queryParameters['filterChargemasterId'] = requestParameters.filterChargemasterId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterReferralNumber) {
            queryParameters['filterReferralNumber'] = requestParameters.filterReferralNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/professional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderProfessionalClaimFromJSON));
    }

    /**
     * Gets a list of professional claims
     * Get a list of professional claims
     */
    async listProviderProfessionalClaims(requestParameters: ListProviderProfessionalClaimsRequest): Promise<Array<ProviderProfessionalClaim>> {
        const response = await this.listProviderProfessionalClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of professional claim templates
     * Get a list of professional claim templates
     */
    async listSupportProfessionalClaimTemplatesRaw(requestParameters: ListSupportProfessionalClaimTemplatesRequest): Promise<runtime.ApiResponse<Array<SupportProfessionalClaimTemplate>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportProfessionalClaimTemplateFromJSON));
    }

    /**
     * Gets a list of professional claim templates
     * Get a list of professional claim templates
     */
    async listSupportProfessionalClaimTemplates(requestParameters: ListSupportProfessionalClaimTemplatesRequest): Promise<Array<SupportProfessionalClaimTemplate>> {
        const response = await this.listSupportProfessionalClaimTemplatesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of professional claims
     * Get a list of professional claims
     */
    async listSupportProfessionalClaimsRaw(requestParameters: ListSupportProfessionalClaimsRequest): Promise<runtime.ApiResponse<Array<SupportProfessionalClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterChargemasterId) {
            queryParameters['filterChargemasterId'] = requestParameters.filterChargemasterId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterReferralNumber) {
            queryParameters['filterReferralNumber'] = requestParameters.filterReferralNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportProfessionalClaimFromJSON));
    }

    /**
     * Gets a list of professional claims
     * Get a list of professional claims
     */
    async listSupportProfessionalClaims(requestParameters: ListSupportProfessionalClaimsRequest): Promise<Array<SupportProfessionalClaim>> {
        const response = await this.listSupportProfessionalClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Post a collection memo
     * Post a collection memo
     */
    async postSupportProfessionalClaimCollectionMemoRaw(requestParameters: PostSupportProfessionalClaimCollectionMemoRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling postSupportProfessionalClaimCollectionMemo.');
        }

        if (requestParameters['supportUpdateProfessionalClaimCollectionMemoPayload'] === null || requestParameters['supportUpdateProfessionalClaimCollectionMemoPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateProfessionalClaimCollectionMemoPayload','Required parameter requestParameters.supportUpdateProfessionalClaimCollectionMemoPayload was null or undefined when calling postSupportProfessionalClaimCollectionMemo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/{pid}/collection_memo`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateProfessionalClaimCollectionMemoPayloadToJSON(requestParameters['supportUpdateProfessionalClaimCollectionMemoPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Post a collection memo
     * Post a collection memo
     */
    async postSupportProfessionalClaimCollectionMemo(requestParameters: PostSupportProfessionalClaimCollectionMemoRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportProfessionalClaimCollectionMemoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Post to set the professional to self pay or not
     * Post to set the professional to self pay or not
     */
    async postSupportProfessionalClaimSelfPayRaw(requestParameters: PostSupportProfessionalClaimSelfPayRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling postSupportProfessionalClaimSelfPay.');
        }

        if (requestParameters['supportUpdateProfessionalClaimSelfPayPayload'] === null || requestParameters['supportUpdateProfessionalClaimSelfPayPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateProfessionalClaimSelfPayPayload','Required parameter requestParameters.supportUpdateProfessionalClaimSelfPayPayload was null or undefined when calling postSupportProfessionalClaimSelfPay.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:professional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/{pid}/self_pay`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateProfessionalClaimSelfPayPayloadToJSON(requestParameters['supportUpdateProfessionalClaimSelfPayPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Post to set the professional to self pay or not
     * Post to set the professional to self pay or not
     */
    async postSupportProfessionalClaimSelfPay(requestParameters: PostSupportProfessionalClaimSelfPayRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportProfessionalClaimSelfPayRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a professional template
     * Replace a professional template
     */
    async replaceSupportProfessionalTemplateRaw(requestParameters: ReplaceSupportProfessionalTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceProfessionalTemplatePayload'] === null || requestParameters['supportReplaceProfessionalTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceProfessionalTemplatePayload','Required parameter requestParameters.supportReplaceProfessionalTemplatePayload was null or undefined when calling replaceSupportProfessionalTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:professional", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/professional/template/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceProfessionalTemplatePayloadToJSON(requestParameters['supportReplaceProfessionalTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a professional template
     * Replace a professional template
     */
    async replaceSupportProfessionalTemplate(requestParameters: ReplaceSupportProfessionalTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportProfessionalTemplateRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderProfessionalClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportProfessionalClaimTemplatesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportProfessionalClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
